// components/PayoutModal.js
import React from 'react';

const PayoutModal = ({ investment, onConfirm, onCancel }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
        <h2 className="text-xl font-bold mb-4">Confirm Payout</h2>
        <div className="space-y-4 mb-6">
          <p>
            <span className="font-semibold">Plan:</span> {investment.InvestmentPlan.planName}
          </p>
          <p>
            <span className="font-semibold">Amount:</span> Rs :{investment.InvestmentPlan.payoutPerCycle}
          </p>
          <p>
            <span className="font-semibold">User:</span> {investment.userId}
          </p>
        </div>
        <div className="flex justify-end space-x-4">
          <button
            onClick={onCancel}
            className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-100"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
          >
            Confirm Payout
          </button>
        </div>
      </div>
    </div>
  );
};

export default PayoutModal;